const map = {
	"./struct1.gif": 19797,
	"./struct10.gif": 74147,
	"./struct11.gif": 8826,
	"./struct12.gif": 67317,
	"./struct2.gif": 37466,
	"./struct3.gif": 44867,
	"./struct4.gif": 3720,
	"./struct5.gif": 4449,
	"./struct6.gif": 73142,
	"./struct7.gif": 93167,
	"./struct8.gif": 28292,
	"./struct9.gif": 30237
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92633;